import { useContext, useState, useEffect } from 'react';
import StudentFormPage from './student/Form';
import FormContext from '../contexts/form/formContext';

const StudentForm = () => {
  const { studentCountValue } = useContext(FormContext);

  const [count, setCount] = useState([]);

  useEffect(() => {
    let val = Array(studentCountValue).fill(studentCountValue);

    setCount(val);
    //eslint-disable-next-line
  }, [studentCountValue]);

  return (
    <>
      {count.map((e, i) => (
        <StudentFormPage key={i} id={i} />
      ))}
    </>
  );
};

export default StudentForm;
